<template>
  <a-card>
    <span slot="title">Master Karyawan</span>
    <div v-if="!isMobile" slot="extra" class="d-flex flex-row">
      <a-input-search v-model="search" placeholder="Pencarian ... " class="m-right" />
      <a-select
        placeholder="Status"
        v-model="status"
        class="w-full"
        allowClear
        style="margin-right: 15px"
      >
        <a-select-option v-for="item in getStatusKaryawan" :key="item.code">{{item.name}}</a-select-option>
      </a-select>
      <a-button type="primary" @click="handleNew" icon="plus">Karyawan Baru</a-button>
    </div>
    <div v-else class="d-flex flex-row m-bottom">
      <a-input-search v-model="search" placeholder="Pencarian ... " class="m-right" />
      <a-button type="primary" icon="plus">{{isMobile ? '' : 'Karyawan Baru'}}</a-button>
    </div>

    <a-list
      :grid="{ gutter: 16, xs: 1, lg: 2, xxl: 3 }"
      :dataSource="searching"
      :pagination="pagination"
    >
      <a-list-item slot="renderItem" slot-scope="item">
        <a-card hoverable @click="handleProfile(item)">
          <div :class="isMobile ? 'd-flex flex-column' : 'd-flex flex-row'">
            <div class="d-flex flex-column align-item-center">
              <div class="photo-wrapper m-bottom">
                <img class="photo-profile" alt="foto-profile" :src="$serviceUrl + item.foto + '?' + pictureTime" />
              </div>
              <!-- <a-button-group>
                <a-button @click="handleProfile(item)">Profile</a-button>
                <a-button @click="handleEdit(item)" type="danger" icon="edit"></a-button>
              </a-button-group>-->
            </div>
            <a-divider v-if="isMobile"></a-divider>
            <ul class="list-wrapper m-left">
              <li>
                <div style="height:50px">
                  <h4 class="m-remove">Nama Pegawai</h4>
                  <span class="m-text-medium">{{item.nama + ' ( ' + item.tlc +' )'}}</span>
                </div>
              </li>
              <li>
                <h4 class="m-remove">Nomor Induk Karyawan</h4>
                <span class="m-text-medium">{{item.nik}}</span>
              </li>
              <li>
                <h4 class="m-remove">Divisi</h4>
                <span class="m-text-medium">{{item.divisi}}</span>
              </li>
              <li>
                <h4 class="text-title m-remove">Status Karyawan</h4>
                <span class="m-text-medium">{{item.status}}</span>
              </li>
            </ul>
          </div>
        </a-card>
      </a-list-item>
    </a-list>
  </a-card>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "list.karyawan",
  data() {
    return {
      datalist: [],
      basedList: [],
      search: "",
      pagination: {
        onChange: page => {
          console.log(page);
        },
        showTotal:total => {return 'Total '+total+' Items data';},
        pageSize: 6,
        size: "small",
      },
      pictureTime : Date(),
      status: undefined,
    };
  },
  computed: {
    ...mapGetters(["getAuth","getStatusKaryawan"]),
    searching() {
      let data = this.datalist;

      if (this.search) {
        data = data.filter(
          item =>
            item.nama && item.nama.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            item.divisi && item.divisi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            item.tlc && item.tlc.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            item.status && item.status.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            item.nik && item.nik.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if(this.status){
        data = data.filter(
        item =>
          item.status && item.status.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
        );
      }

      return data;
    },
  },
  created(){
    this.$store.dispatch("FETCH_STATUSKARYAWAN");
  },
  activated() {
    this.pictureTime = Date();
  },
  methods: {
    async fetching() {
      await axios({
        method: "get",
        url: this.$serviceUrl + "master_karyawan",
        params: {
          "X-API-KEY": this.getAuth.apikey
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        }
      })
        .then(response => {
          this.datalist = response.data.list_karyawan;
          this.basedList = response.data.list_karyawan;
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    handleProfile(item) {
      this.$router.push({
        name: "hrd.karyawan.profile",
        params: { tlc: item.tlc }
      });
    },
    handleEdit(item) {
      this.$router.push({
        name: "karyawanrubah",
        params: { tlc: item.tlc, nik: item.nik }
      });
    },
    handleNew() {
      this.$router.push({ name: "karyawanbaru" });
    },
  },
  mounted() {
    this.fetching();
  }
};
</script>

<style>
</style>